import { FC } from 'react';
import { Drawer } from 'shared/ui/drawer/drawer';
import { Card } from 'shared/ui/card/card';
import { Icon } from 'shared/ui/icon/icon';
import { ICONS } from 'shared/constants/images';
import { useTranslation } from 'hooks';
import { COMPARE_FEATURES } from './compare-plans-drawer.constants';
import type { ComparePlansDrawerProps } from './compare-plans-drawer.types';
import cls from './compare-plans-drawer.module.scss';

export const ComparePlansDrawer: FC<ComparePlansDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer isOpen={isOpen} onClose={onClose} title={t('planDetails')}>
      <Card className={cls.drawerCard}>
        <p className={cls.introText}>{t('comparePlansIntroCore')}</p>

        <table className={cls.compareTable}>
          <thead>
            <tr>
              <th className={cls.featureCol} />
              <th className={cls.planCol}>
                {t('corePlan', '_global', 'Core plan')}
              </th>
            </tr>
          </thead>
          <tbody>
            {COMPARE_FEATURES.map(feature => (
              <tr key={feature.key}>
                <td className={cls.featureCell}>
                  <span className={cls.featureName}>{t(feature.key)}</span>
                  <span className={cls.featureDescription}>
                    {t(feature.descriptionKey)}
                  </span>
                </td>
                <td className={cls.featureValue}>
                  <Icon pathToIcon={ICONS.checkMarkGreen} size={20} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </Drawer>
  );
};
